import {
  postFacebookLogin,
  postLogin,
  postLoginApple,
  postLoginGoogle,
  postLoginKakao,
  postLoginNaver,
} from "@/services/api/auth";
import { postSubscribePushNotification } from "@/services/api/notification.api";
import { getUserInfo } from "@/services/api/user";
import { StorageKey, VapidKey } from "@/services/constants/global";

export const createSignInAction = async (payload) => {
  const response = await postLogin(payload);
  if (!response.errorCode) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};

export const facebookSignInAction = async (payload) => {
  const response = await postFacebookLogin(payload);
  if (response) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};

export const kakaoSignInAction = async (payload) => {
  const response = await postLoginKakao(payload);
  if (response) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};

export const naverSignInAction = async (payload) => {
  const response = await postLoginNaver(payload);
  if (response) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};

export const subscribePushNotification = () => {
  if ("serviceWorker" in navigator) {
    const handleServiceWorker = async () => {
      const register = await navigator.serviceWorker.register("/sw.js?v=1");
      const subscription = await register.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: VapidKey,
      });
      await postSubscribePushNotification({ subscription });
    };
    handleServiceWorker();
  }
};

export const appleSignAction = async (payload) => {
  const response = await postLoginApple(payload);
  if (response) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};

export const googleSignAction = async (payload) => {
  const response = await postLoginGoogle(payload);
  if (response) {
    if (payload.keepLogin) {
      localStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    } else {
      sessionStorage.setItem(
        StorageKey.xToken,
        JSON.stringify(response.accessToken)
      );
    }
    await getUserInfo();
  }
  return response;
};
